"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _createConnect = require("./create-connect");
var _defaultContext = require("./default-context");
var _jsxRuntime = require("react/jsx-runtime");
var TranslatorProvider = function TranslatorProvider(_ref) {
  var context = _ref.context,
    locale = _ref.locale,
    translations = _ref.translations,
    children = _ref.children;
  var C = (0, _defaultContext.useCustomContextOrDefault)(context);
  var t = (0, _createConnect.getTranslator)(locale, translations, context);
  var providerValue = {
    locale: locale,
    translations: translations,
    t: t
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(C.Provider, {
    value: providerValue,
    children: children
  });
};
TranslatorProvider.propTypes = {
  locale: _propTypes["default"].string,
  translations: _propTypes["default"].object,
  context: _propTypes["default"].object,
  children: _propTypes["default"].node
};
var _default = TranslatorProvider;
exports["default"] = _default;